//angular imports
import { 
  ChangeDetectionStrategy,
  Component,
  input
} from "@angular/core";

//local imports
import {
  CloseDialogMessage,
  CommandModel,
  Messenger,
} from "@app/shared";

import {
  CreateDepartmentRequest,
  DepartmentAlreadyExistsMessage,
  DepartmentDetails,
  DepartmentHttpService,
  ProgramProjectMismatchFault,
  ProgramProjectMismatchMessage,
  ProgramModel,
  ProjectModel
} from "@app/catalog";


import { ToastLevel, ToastMessage } from "@app/components";
import { DepartmentAlreadyExistsFault } from "@app/catalog-common";

@Component({
  selector: "add-department-form",
  templateUrl: "./add-department-form.component.html",
  styleUrl: "./add-department-form.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AddDepartmentFormComponent {
  public details = DepartmentDetails.empty();

  public companyId = input.required<string>();
  public programs = input.required<ProgramModel[]>();
  public projects = input.required<ProjectModel[]>();

  public cancelCommand = new CommandModel({
    executeAction: () => {
      this.messenger.send(new CloseDialogMessage());
      return Promise.resolve();
    },
  });

  public submitCommand = new CommandModel({
    executeAction: () => this.save(),
    isValid: this.details.isValid,
  });

  constructor(
    private departmentHttpService: DepartmentHttpService,
    private messenger: Messenger,
  ) {}

  private save = async () => {
    let request = new CreateDepartmentRequest();

    request.code = this.details.code.value();
    request.name = this.details.name.value();
    request.programId = this.details.program.value();
    request.projectId = this.details.project.value();
    request.companyId = this.companyId();

    let createResult = this.departmentHttpService.create(request);

    try {
      await createResult.response;
      this.messenger.send(new CloseDialogMessage());
    } catch (error) {
      if (error instanceof DepartmentAlreadyExistsFault) {
        this.messenger.send(
          ToastMessage.create(
            new DepartmentAlreadyExistsMessage(error.code),
            ToastLevel.Warning,
          ),
        );
      } else if (error instanceof ProgramProjectMismatchFault) {
        let program = this.programs().find(item => item.id === request.programId);
        let project = this.projects().find(item => item.id === request.projectId);

        this.messenger.send(
          ToastMessage.create(
            new ProgramProjectMismatchMessage(program.name(), project.name()),
            ToastLevel.Warning,
          ),
        );
      }
      return;
    }
  };
}
